import { Badge } from "react-bootstrap";

const GROUP_BADGE_VARIANTS: Record<string, string> = {
  GlobalAdmin: "danger",
  SeniorManagement: "danger",
  AdminManager: "warning",
  SalesManager: "warning",
  AdminMember: "info",
  SalesMember: "info",
};

export const getGroupBadgeVariant = (group: string): string =>
  GROUP_BADGE_VARIANTS[group] ?? "secondary";

interface GroupBadgeProps {
  group: string;
  className?: string;
}

const GroupBadge: React.FC<GroupBadgeProps> = ({ group, className }) => (
  <Badge bg={getGroupBadgeVariant(group)} className={className}>
    {group}
  </Badge>
);

export default GroupBadge;
